import { type MouseEvent } from 'react';
import { List, Tag, Typography, Button } from 'antd';
import { FallBackdata } from './types';
import { renderDescriptionForCompressors } from './Fallbacks.utils';
import { useTranslation } from 'react-i18next';
import { EngineConfigStatus } from '@/store/Engine/constants';

const { Text } = Typography;

interface FallbackListProps {
  filteredList: FallBackdata[];
  selectedId: number;
  onListItemClick: (item: FallBackdata) => void;
  onViewButtonClick: (e: MouseEvent, item: FallBackdata) => void;
  compressors;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
    onChange: (page: number, pageSize: number) => void;
  };
  isDraftMode: boolean;
  fromVersionHistory: boolean;
  configurationStatus: EngineConfigStatus;
}

const FallbackList = ({
  filteredList,
  selectedId,
  onListItemClick,
  onViewButtonClick,
  compressors,
  pagination,
  isDraftMode,
  fromVersionHistory,
  configurationStatus,
}: FallbackListProps) => {
  const { t } = useTranslation();

  const handleListItemClick = (item: FallBackdata) => {
    onListItemClick(item);
  };

  const handleViewButtonClick = (e: MouseEvent, item: FallBackdata) => {
    onViewButtonClick(e, item);
  };

  const shouldShowActiveBadge = !isDraftMode && !fromVersionHistory && configurationStatus !== EngineConfigStatus.Recommendation;

  const renderListItem = (item: FallBackdata) => {
    const handleItemClick = () => handleListItemClick(item);
    const handleButtonClick = (e: MouseEvent) => handleViewButtonClick(e, item);

    return (
      <List.Item
        className={`list-item-fallback-two-point-o ${
          item.id === selectedId ? 'active' : ''
        }`}
        onClick={handleItemClick}
      >
      <div className="list-item-content-fallback-two-point-o">
        <div>
          {item.active && shouldShowActiveBadge && (
            <Tag className="active-badge-fallback-two-point-o">
              <div className="icon">!</div>
              {t('currentlyActive')}
            </Tag>
          )}
        </div>
        <Text strong className="list-item-title">
          {item.title}
        </Text>
        <div className="description-text-fallback-two-point-o">
          {renderDescriptionForCompressors(item.scenario, compressors, t)}
        </div>
      </div>

      {item.id !== selectedId && (
        <Button
          type="link"
          className="view-button-fallback-two-point-o"
          onClick={handleButtonClick}
        >
          {t('view')}
        </Button>
      )}
    </List.Item>
    );
  };

  return (
    <div className="left-panel-fallback-two-point-o">
      <div className="fallback-list-container-fallback-two-point-o">
        <List
          dataSource={filteredList}
          pagination={pagination}
          renderItem={renderListItem}
        />
      </div>
    </div>
  );
};

export default FallbackList;
